import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "../../../utils/customModal";
import Tooltip from "canvas-core-react/lib/Tooltip";
import CheckBox from "canvas-core-react/lib/Checkbox";
import * as instanceActions from "../../../../Redux/api";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { getInstitutionsProfile } from "../../../../Redux/reducer/clients";
import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
} from "../../../utils/functions";
import LockUser from "../../../../../static/images/user-lock.svg";
import { withTranslation } from "react-i18next";

export class UserRoles extends Component {
  constructor(props) {
    super(props);

    var readOnly = true;
    if (props.canEdit === true) {
      // Permisos de escritura
      readOnly = props.editUser;
    }

    this.state = {
      user: props.user,
      saveState: "",
      modalContent: null,
      openModal: false,
      showClose: false,
      readOnly: readOnly,
    };
  }

  handlerChange = (event) => {
    const { user } = this.state;
    var module = event.target.name.split("-");
    if (
      user.modules[module[0]] !== undefined &&
      user.modules[module[0]].permissions[module[1]] !== undefined
    ) {
      user.modules[module[0]].permissions[module[1]].assigned =
        event.target.checked;
    }

    this.setState({ user });
  };

  handlerChangeRelated = (event) => {
    const { user } = this.state;
    var client = event.target.name.split("-");
    if (
      user.relatedCompanyWrappers[client[0]] !== undefined &&
      user.relatedCompanyWrappers[client[0]].relatedCompanyCreditLineList[
        client[1]
      ] !== undefined
    ) {
      user.relatedCompanyWrappers[client[0]].relatedCompanyCreditLineList[
        client[1]
      ].assigned = event.target.checked;
    }

    this.setState({ user });
  };

  modalFunction = () => {
    var buttons = {
      SelBtn: {
        text: "Continuar",
        action: () => this.props.endStep(),
      },
    };

    var modalContent = sucessInfoModal(
      "Gestión de usuarios",
      `El proceso se ha realizado con éxito.`,
      buttons
    );
    this.setState({
      modalContent,
      openModal: true,
      showClose: true,
    });
  };

  modalFunctionError = () => {
    var buttons = {
      SelBtn: {
        text: "Continuar",
        action: () => this.props.endStep(),
      },
    };

    const { errorTitle, errorDescription } = this.props.t(
      "clients.modal.modules",
      { returnObjects: true }
    );

    this.setState({
      modalContent: errorContainer(errorTitle, errorDescription, buttons),
      openModal: true,
      showClose: true,
    });
  };

  createUser = () => {
    this.setState({
      modalContent: loadingHtml(),
      openModal: true,
      showClose: false,
    });
    const {
      client,
      instance: { instanceAction },
    } = this.props;
    var data = {
      notifications: null,
      data: this.state.user,
    };

    return instanceAction(
      `users/${client.businessId}/${client.country.code}/${"CSA"}`,
      "put",
      data
    )
      .then(() => this.modalFunction())
      .catch(() => this.modalFunctionError());
  };

  closeModal = () => {
    this.setState({
      openModal: false,
      modalContent: null,
      showClose: false,
    });
    this.props.endStep();
  };

  back() {
    this.props.goBack(this.state.user);
  }

  pendingData = (moduleId) => {
    const { user } = this.state;
    var data = user.recordsTmp !== null ? user.recordsTmp.data : null;
    var permissions =
      data !== null && data.permissions !== ""
        ? JSON.parse(data.permissions)
        : null;

    var existModule =
      permissions !== null
        ? permissions.some((perm) => perm.modId == moduleId)
        : false;

    return (
      existModule && (
        <div className="flex-element">
          <div className="left-flex fix-tooltip">
            <Tooltip
              id="tooltip-id"
              closeButtonLabel="Close Tooltip"
              infoButtonLabel="Info"
              position={"bottom"}
              heading={"Pendiente de aprobación"}
            >
              <label className="edited-client-info tooltip-color">
                {`Estos permisos se encuentran pendientes de aprobación`}
              </label>
            </Tooltip>
          </div>
        </div>
      )
    );
  };

  render() {
    const { user, readOnly } = this.state;
    const { t } = this.props;
    const { title, buttons } = {
      title: t("clients.users.form.roles.title"),
      buttons: t("general.buttons", { returnObjects: true }),
    };

    return (
      user !== null && (
        <div id="add-client-user">
          <div className="head">
            <h2 className="title">{title}</h2>
          </div>
          <div className="card-element clearfix">
            {user.modules && user.modules.length > 0 ? (
              user.modules.map((module, key) => (
                <div key={`${module.id}-${key}`} className="loaded-module-user">
                  <div className="flex-element">
                    <p>{module.displayName}</p>
                    {this.pendingData(module.id)}
                  </div>
                  <div className="roles">
                    {module.permissions.map((permission, moduleKey) => (
                      <CheckBox
                        key={`${module.code}-${permission.code}`}
                        id={`${module.code}-${permission.code}`}
                        name={`${key}-${moduleKey}`}
                        label={permission.displayName}
                        checked={permission.assigned}
                        disabled={readOnly}
                        onChange={(event) => this.handlerChange(event)}
                      />
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div className="blank-modules">
                <img src={LockUser} />
                <p>
                  Estimado usuario de momento el sistema no presenta módulos por
                  asignar.
                </p>
                <div className="line red"></div>
              </div>
            )}
          </div>
          {user.relatedCompanyWrappers.length > 0 && (
            <>
              <div className="head">
                <h2 className="title">Cuentas</h2>
              </div>
              {user.relatedCompanyWrappers.map((related, key) => (
                <div key={`related-${key}`} className="row related-companies">
                  <div className="col-4">
                    <h3>{related.nameCompany}</h3>
                    {related.relatedCompanyCreditLineList.map((line, idx) => (
                      <div key={`account-${idx}`} className="accounts">
                        <CheckBox
                          key={`account-${key}-${idx}`}
                          id={`account-${key}-${idx}`}
                          name={`${key}-${idx}`}
                          label={`Cuenta: ${line.accountCurrency} - ${line.accountNumber}`}
                          checked={line.assigned}
                          disabled={readOnly}
                          onChange={(e) => this.handlerChangeRelated(e)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}
          <div className="form-actions clearfix">
            <SecondaryButton id="closeRoles" onClick={() => this.back()}>
              {buttons.back}
            </SecondaryButton>
            {readOnly === false && (
              <SecondaryButton
                id="sendForApproval"
                onClick={() => this.createUser()}
              >
                {buttons.sendForApproval}
              </SecondaryButton>
            )}
          </div>
          <Modal
            key={`approval-modal`}
            show={this.state.openModal}
            handleClose={() => this.closeModal()}
            showClose={this.state.showClose}
          >
            {this.state.modalContent}
          </Modal>
        </div>
      )
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    client: getInstitutionsProfile(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(UserRoles))
);
